import { default as BrightyDogPng } from './brand/brighty/BrightyDog.png';
import { default as BrightyDogWebP } from './brand/brighty/BrightyDog.webp';
import { default as BrightyDogAvif } from './brand/brighty/BrightyDog.avif';
import { ImageProps, image } from './image';

export function GraphicsDogImage(props: ImageProps) {
  return __BRIGHTY__ ? image(props, BrightyDogPng, BrightyDogWebP, BrightyDogAvif) : null;
}
